import React from 'react'
import PropTypes from 'prop-types'
import Card from 'react-bootstrap/Card'
import TagIcon from 'tag/icon'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import renderDescription from 'shared/render-description'
import RecipePlainSummary from './RecipePlainSummary'

function DescriptionCard({ analytic }) {
  return (
    <>
      <Card>
        <Card.Body>
          <Row>
            <Col>
              <span className="fw-bold">Module</span>
              <div className="fw-light mt-2">{analytic.section_name}</div>
            </Col>
            <Col>
              <span className="fw-bold">Tags</span>
              <div className="pt-2">
                {analytic.tags.map((t) => (
                  <span
                    className="me-1"
                    key={`analytic-${analytic.id}-tag-${t.id}`}
                  >
                    <TagIcon tagName={t.name} tagDescription={t.description} />
                  </span>
                ))}
                {analytic.family_tags && analytic.family_tags.length > 0 &&
                  analytic.family_tags.map((t) => (
                    <span
                      className="me-1"
                      key={`analytic-${analytic.id}-family-tag-${t.id}`}
                    >
                      <TagIcon tagName={t.name} tagDescription={t.description} />
                    </span>
                  ))}
              </div>
            </Col>
          </Row>
          <div className="mt-4">
            <div className="fw-bold">Description</div>
            <div className="fw-light mt-2">
              {/* Custom analytics describe themselves in plain English straight
                  from the recipe; core analytics keep their curated text. */}
              {analytic.custom ? (
                <RecipePlainSummary recipe={analytic.recipe} predicates={analytic.recipe_predicates} />
              ) : (
                renderDescription(analytic.description, analytic.column_sources)
              )}
            </div>
          </div>
          {analytic.fraud_tags.length > 0 && (
            <>
              <div className="fw-bold mt-4">Possible Fraud Schemes</div>
              <div className="pt-2">
                {analytic.fraud_tags.map((t) => (
                  <span
                    className="me-1"
                    key={`analytic-${analytic.id}-tag-${t.id}`}
                  >
                    <TagIcon tagName={t.name} tagDescription={t.description} />
                  </span>
                ))}
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  )
}

DescriptionCard.propTypes = {
  analytic: PropTypes.object.isRequired
}

export default DescriptionCard
